const now = new Date();
const daysAgo = (d) => new Date(now.getTime() - d * 86400000).toISOString();
const daysLater = (d) => new Date(now.getTime() + d * 86400000).toISOString().split('T')[0];

export const ISSUE_TYPES = [
  'Electrical', 'Plumbing', 'HVAC/AC', 'Carpentry', 'Painting',
  'Flooring', 'Roofing', 'Glass/Window', 'Door/Lock', 'Fire Safety',
  'Signage', 'Pest Control', 'Deep Cleaning', 'Civil Work', 'IT/Network', 'Other'
];

export const INDIAN_STATES = [
  'Andhra Pradesh', 'Bihar', 'Delhi', 'Goa', 'Gujarat', 'Haryana',
  'Karnataka', 'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Punjab',
  'Rajasthan', 'Tamil Nadu', 'Telangana', 'Uttar Pradesh', 'West Bengal'
];

export const PRIORITIES = [
  { value: 'low', label: 'Low', color: 'bg-blue-100 text-blue-700' },
  { value: 'medium', label: 'Medium', color: 'bg-yellow-100 text-yellow-700' },
  { value: 'high', label: 'High', color: 'bg-orange-100 text-orange-700' },
  { value: 'emergency', label: 'Emergency', color: 'bg-red-100 text-red-700' }
];

export const STATUS_CONFIG = {
  'Pending Approval': { color: 'bg-yellow-100 text-yellow-800', border: 'border-yellow-200' },
  'Approved': { color: 'bg-blue-100 text-blue-800', border: 'border-blue-200' },
  'Rejected': { color: 'bg-red-100 text-red-800', border: 'border-red-200' },
  'Assigned': { color: 'bg-purple-100 text-purple-800', border: 'border-purple-200' },
  'Rate Negotiation': { color: 'bg-cyan-100 text-cyan-800', border: 'border-cyan-200' },
  'In Progress': { color: 'bg-indigo-100 text-indigo-800', border: 'border-indigo-200' },
  'Resolved': { color: 'bg-emerald-100 text-emerald-800', border: 'border-emerald-200' },
  'Closed': { color: 'bg-gray-100 text-gray-800', border: 'border-gray-200' },
  'Reopened': { color: 'bg-orange-100 text-orange-800', border: 'border-orange-200' },
  'Escalated': { color: 'bg-rose-100 text-rose-800', border: 'border-rose-200' },
  'Overdue': { color: 'bg-red-200 text-red-900', border: 'border-red-300' }
};

export const mockStores = [
  { id: 'STR001', locCode: 'MUM-001', locName: 'Mumbai Central Mall', state: 'Maharashtra', contactNo: '9876543210', city: 'Mumbai' },
  { id: 'STR002', locCode: 'DEL-001', locName: 'Delhi CP Plaza', state: 'Delhi', contactNo: '9876543211', city: 'New Delhi' },
  { id: 'STR003', locCode: 'BLR-001', locName: 'Bangalore Indiranagar', state: 'Karnataka', contactNo: '9876543212', city: 'Bangalore' },
  { id: 'STR004', locCode: 'CHN-001', locName: 'Chennai T Nagar', state: 'Tamil Nadu', contactNo: '9876543213', city: 'Chennai' },
  { id: 'STR005', locCode: 'HYD-001', locName: 'Hyderabad Banjara Hills', state: 'Telangana', contactNo: '9876543214', city: 'Hyderabad' },
  { id: 'STR006', locCode: 'AHM-001', locName: 'Ahmedabad SG Highway', state: 'Gujarat', contactNo: '9876543215', city: 'Ahmedabad' },
  { id: 'STR007', locCode: 'PUN-001', locName: 'Pune FC Road', state: 'Maharashtra', contactNo: '9876543216', city: 'Pune' },
  { id: 'STR008', locCode: 'JAI-001', locName: 'Jaipur MI Road', state: 'Rajasthan', contactNo: '9876543217', city: 'Jaipur' },
  { id: 'STR009', locCode: 'KOL-001', locName: 'Kolkata Park Street', state: 'West Bengal', contactNo: '9876543218', city: 'Kolkata' },
  { id: 'STR010', locCode: 'KOC-001', locName: 'Kochi MG Road', state: 'Kerala', contactNo: '9876543219', city: 'Kochi' },
];

export const mockVendors = [
  { id: 'VND001', name: 'QuickFix Electricals', contactNo: '9988776601', email: 'quickfix@vendor.com', specialization: 'Electrical', rating: 4.5, amcStatus: 'AMC', completedJobs: 156, location: 'Mumbai' },
  { id: 'VND002', name: 'AquaFlow Plumbing', contactNo: '9988776602', email: 'aquaflow@vendor.com', specialization: 'Plumbing', rating: 4.2, amcStatus: 'Non-AMC', completedJobs: 98, location: 'Delhi' },
  { id: 'VND003', name: 'CoolBreeze HVAC', contactNo: '9988776603', email: 'coolbreeze@vendor.com', specialization: 'HVAC/AC', rating: 4.7, amcStatus: 'AMC', completedJobs: 203, location: 'Bangalore' },
  { id: 'VND004', name: 'WoodCraft Solutions', contactNo: '9988776604', email: 'woodcraft@vendor.com', specialization: 'Carpentry', rating: 4.0, amcStatus: 'Non-AMC', completedJobs: 67, location: 'Chennai' },
  { id: 'VND005', name: 'ProPaint Services', contactNo: '9988776605', email: 'propaint@vendor.com', specialization: 'Painting', rating: 4.3, amcStatus: 'AMC', completedJobs: 145, location: 'Hyderabad' },
  { id: 'VND006', name: 'SafeGuard Fire Systems', contactNo: '9988776606', email: 'safeguard@vendor.com', specialization: 'Fire Safety', rating: 4.8, amcStatus: 'AMC', completedJobs: 89, location: 'Mumbai' },
  { id: 'VND007', name: 'CleanSpace Facility', contactNo: '9988776607', email: 'cleanspace@vendor.com', specialization: 'Deep Cleaning', rating: 4.1, amcStatus: 'Non-AMC', completedJobs: 234, location: 'Pune' },
  { id: 'VND008', name: 'BuildRight Civil', contactNo: '9988776608', email: 'buildright@vendor.com', specialization: 'Civil Work', rating: 4.4, amcStatus: 'AMC', completedJobs: 112, location: 'Ahmedabad' },
];

export const mockUsers = [
  { id: 'USR001', name: 'Rajesh Kumar', email: 'admin@nicobar.com', password: 'admin123', role: 'admin', avatar: 'RK', phone: '9876500001' },
  { id: 'USR005', name: 'Neha Gupta', email: 'admin2@nicobar.com', password: 'admin123', role: 'admin', avatar: 'NG', phone: '9876500005' },
  { id: 'USR002', name: 'Priya Sharma', email: 'store@nicobar.com', password: 'store123', role: 'store', storeId: 'STR001', avatar: 'PS', phone: '9876500002' },
  { id: 'USR006', name: 'Vikram Singh', email: 'store2@nicobar.com', password: 'store123', role: 'store', storeId: 'STR002', avatar: 'VS', phone: '9876500006' },
  { id: 'USR007', name: 'Anita Desai', email: 'store3@nicobar.com', password: 'store123', role: 'store', storeId: 'STR003', avatar: 'AD', phone: '9876500007' },
  { id: 'USR003', name: 'Amit Patel', email: 'vendor@nicobar.com', password: 'vendor123', role: 'vendor', vendorId: 'VND001', avatar: 'AP', phone: '9876500003' },
  { id: 'USR008', name: 'Ravi Menon', email: 'vendor2@nicobar.com', password: 'vendor123', role: 'vendor', vendorId: 'VND003', avatar: 'RM', phone: '9876500008' },
  { id: 'USR004', name: 'Sunita Reddy', email: 'superadmin@nicobar.com', password: 'super123', role: 'superadmin', avatar: 'SR', phone: '9876500004' },
];

export const mockTickets = [
  {
    id: 'TKT-2025-0001', locCode: 'MUM-001', locName: 'Mumbai Central Mall', state: 'Maharashtra',
    storeContactNo: '9876543210', issueType: 'Electrical', priority: 'high',
    description: 'Main power panel in section B showing sparks and tripping frequently. Immediate attention required for safety.',
    photoUrl: 'https://images.unsplash.com/photo-1621905252507-b35492CC74b4?w=300', videoUrl: null,
    status: 'In Progress', createdBy: 'USR002', createdByName: 'Priya Sharma', createdDate: daysAgo(3),
    approvedBy: 'USR001', approvedByName: 'Rajesh Kumar', approveDate: daysAgo(3),
    assignedTo: 'VND001', vendorName: 'QuickFix Electricals', vendorContactNo: '9988776601',
    expectedDate: daysLater(1), otpSent: true, vendorOtp: '482916',
    remarks: 'Urgent - safety hazard', amcType: 'AMC',
    quotedRate: 15000, vendorCounterRate: null, finalizedRate: 15000, rateFinalized: true, rateStatus: 'finalized',
    rateHistory: [{ by: 'Rajesh Kumar', rate: 15000, date: daysAgo(3), action: 'quoted' }, { by: 'QuickFix Electricals', rate: 15000, date: daysAgo(3), action: 'accepted' }],
    vendorMedia: [], repairPhotoUrl: null, actualCost: null,
    statusLogs: [
      { status: 'Pending Approval', date: daysAgo(3), by: 'System', remarks: 'Ticket created' },
      { status: 'Approved', date: daysAgo(3), by: 'Rajesh Kumar', remarks: 'Approved - urgent safety issue' },
      { status: 'Assigned', date: daysAgo(3), by: 'Rajesh Kumar', remarks: 'Assigned to QuickFix Electricals | Rate: ₹15,000' },
      { status: 'In Progress', date: daysAgo(2), by: 'QuickFix Electricals', remarks: 'Rate accepted. Work started on site' },
    ]
  },
  {
    id: 'TKT-2025-0002', locCode: 'DEL-001', locName: 'Delhi CP Plaza', state: 'Delhi',
    storeContactNo: '9876543211', issueType: 'HVAC/AC', priority: 'medium',
    description: 'Central AC unit on 2nd floor not cooling properly. Temperature readings above 28\u00b0C during peak hours.',
    photoUrl: 'https://images.unsplash.com/photo-1585338107529-13afc5f02586?w=300', videoUrl: null,
    status: 'Rate Negotiation', createdBy: 'USR006', createdByName: 'Vikram Singh', createdDate: daysAgo(2),
    approvedBy: 'USR001', approvedByName: 'Rajesh Kumar', approveDate: daysAgo(2),
    assignedTo: 'VND003', vendorName: 'CoolBreeze HVAC', vendorContactNo: '9988776603',
    expectedDate: daysLater(2), otpSent: false, vendorOtp: null,
    remarks: 'Vendor proposed lower rate', amcType: 'AMC',
    quotedRate: 10000, vendorCounterRate: 7500, finalizedRate: null, rateFinalized: false, rateStatus: 'countered',
    rateHistory: [{ by: 'Rajesh Kumar', rate: 10000, date: daysAgo(2), action: 'quoted' }, { by: 'CoolBreeze HVAC', rate: 7500, date: daysAgo(1), action: 'countered' }],
    vendorMedia: [], repairPhotoUrl: null, actualCost: null,
    statusLogs: [
      { status: 'Pending Approval', date: daysAgo(2), by: 'System', remarks: 'Ticket created' },
      { status: 'Approved', date: daysAgo(2), by: 'Rajesh Kumar', remarks: 'Approved' },
      { status: 'Assigned', date: daysAgo(1), by: 'Rajesh Kumar', remarks: 'Assigned to CoolBreeze HVAC | Rate: ₹10,000' },
      { status: 'Rate Negotiation', date: daysAgo(1), by: 'CoolBreeze HVAC', remarks: 'Counter-proposed ₹7,500' },
    ]
  },
  {
    id: 'TKT-2025-0003', locCode: 'BLR-001', locName: 'Bangalore Indiranagar', state: 'Karnataka',
    storeContactNo: '9876543212', issueType: 'Plumbing', priority: 'emergency',
    description: 'Major water leak in basement storage area. Water spreading to inventory section. Urgent fix needed.',
    photoUrl: 'https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?w=300', videoUrl: null,
    status: 'Resolved', createdBy: 'USR007', createdByName: 'Anita Desai', createdDate: daysAgo(5),
    approvedBy: 'USR001', approvedByName: 'Rajesh Kumar', approveDate: daysAgo(5),
    assignedTo: 'VND002', vendorName: 'AquaFlow Plumbing', vendorContactNo: '9988776602',
    expectedDate: daysAgo(3), otpSent: true, vendorOtp: '739284',
    remarks: 'Emergency - inventory at risk', amcType: 'Non-AMC',
    quotedRate: 28000, vendorCounterRate: 22000, finalizedRate: 22000, rateFinalized: true, rateStatus: 'finalized',
    rateHistory: [{ by: 'Rajesh Kumar', rate: 28000, date: daysAgo(5), action: 'quoted' }, { by: 'AquaFlow Plumbing', rate: 22000, date: daysAgo(5), action: 'countered' }, { by: 'Rajesh Kumar', rate: 22000, date: daysAgo(5), action: 'accepted' }],
    vendorMedia: [
      { type: 'photo', url: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=300', name: 'pipe_repair_1.jpg', uploadedAt: daysAgo(3) },
      { type: 'photo', url: 'https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?w=300', name: 'pipe_repair_2.jpg', uploadedAt: daysAgo(3) },
      { type: 'video', url: '#', name: 'repair_walkthrough.mp4', uploadedAt: daysAgo(3) }
    ],
    repairPhotoUrl: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=300', actualCost: 22000,
    statusLogs: [
      { status: 'Pending Approval', date: daysAgo(5), by: 'System', remarks: 'Ticket created' },
      { status: 'Approved', date: daysAgo(5), by: 'Rajesh Kumar', remarks: 'Emergency approved' },
      { status: 'Assigned', date: daysAgo(5), by: 'Rajesh Kumar', remarks: 'Assigned to AquaFlow | Rate: ₹28,000' },
      { status: 'Rate Negotiation', date: daysAgo(5), by: 'AquaFlow Plumbing', remarks: 'Counter: ₹22,000' },
      { status: 'Assigned', date: daysAgo(5), by: 'Rajesh Kumar', remarks: 'Rate accepted: ₹22,000' },
      { status: 'In Progress', date: daysAgo(4), by: 'AquaFlow Plumbing', remarks: 'Team dispatched' },
      { status: 'Resolved', date: daysAgo(3), by: 'AquaFlow Plumbing', remarks: 'Leak fixed, pipe replaced. OTP verified.' },
    ]
  },
  {
    id: 'TKT-2025-0004', locCode: 'CHN-001', locName: 'Chennai T Nagar', state: 'Tamil Nadu',
    storeContactNo: '9876543213', issueType: 'Painting', priority: 'low',
    description: 'Wall paint peeling off in customer area near entrance. Needs repainting for better appearance.',
    photoUrl: null, videoUrl: null,
    status: 'Pending Approval', createdBy: 'USR002', createdByName: 'Priya Sharma', createdDate: daysAgo(1),
    approvedBy: null, approvedByName: null, approveDate: null,
    assignedTo: null, vendorName: null, vendorContactNo: null,
    expectedDate: null, otpSent: false, vendorOtp: null, remarks: '', amcType: 'Non-AMC',
    quotedRate: null, vendorCounterRate: null, finalizedRate: null, rateFinalized: false, rateStatus: null,
    rateHistory: [], vendorMedia: [], repairPhotoUrl: null, actualCost: null,
    statusLogs: [{ status: 'Pending Approval', date: daysAgo(1), by: 'System', remarks: 'Ticket created' }]
  },
  {
    id: 'TKT-2025-0005', locCode: 'HYD-001', locName: 'Hyderabad Banjara Hills', state: 'Telangana',
    storeContactNo: '9876543214', issueType: 'Fire Safety', priority: 'emergency',
    description: 'Fire extinguisher expired in main hall. Fire alarm panel showing error codes.',
    photoUrl: null, videoUrl: null,
    status: 'Pending Approval', createdBy: 'USR006', createdByName: 'Vikram Singh', createdDate: daysAgo(0),
    approvedBy: null, approvedByName: null, approveDate: null,
    assignedTo: null, vendorName: null, vendorContactNo: null,
    expectedDate: null, otpSent: false, vendorOtp: null, remarks: '', amcType: 'AMC',
    quotedRate: null, vendorCounterRate: null, finalizedRate: null, rateFinalized: false, rateStatus: null,
    rateHistory: [], vendorMedia: [], repairPhotoUrl: null, actualCost: null,
    statusLogs: [{ status: 'Pending Approval', date: daysAgo(0), by: 'System', remarks: 'Ticket created' }]
  },
  {
    id: 'TKT-2025-0006', locCode: 'AHM-001', locName: 'Ahmedabad SG Highway', state: 'Gujarat',
    storeContactNo: '9876543215', issueType: 'Door/Lock', priority: 'high',
    description: 'Main entrance automatic door stuck in open position. Security concern at night.',
    photoUrl: null, videoUrl: null,
    status: 'Closed', createdBy: 'USR007', createdByName: 'Anita Desai', createdDate: daysAgo(10),
    approvedBy: 'USR001', approvedByName: 'Rajesh Kumar', approveDate: daysAgo(10),
    assignedTo: 'VND004', vendorName: 'WoodCraft Solutions', vendorContactNo: '9988776604',
    expectedDate: daysAgo(7), otpSent: true, vendorOtp: '192837', remarks: 'Fixed and confirmed', amcType: 'Non-AMC',
    quotedRate: 18000, vendorCounterRate: 16500, finalizedRate: 16500, rateFinalized: true, rateStatus: 'finalized',
    rateHistory: [{ by: 'Rajesh Kumar', rate: 18000, date: daysAgo(10), action: 'quoted' }, { by: 'WoodCraft Solutions', rate: 16500, date: daysAgo(9), action: 'countered' }, { by: 'Rajesh Kumar', rate: 16500, date: daysAgo(9), action: 'accepted' }],
    vendorMedia: [{ type: 'photo', url: 'https://images.unsplash.com/photo-1558618666-fcd25c85f82e?w=300', name: 'door_fixed.jpg', uploadedAt: daysAgo(8) }],
    repairPhotoUrl: null, actualCost: 16500,
    statusLogs: [
      { status: 'Pending Approval', date: daysAgo(10), by: 'System', remarks: 'Ticket created' },
      { status: 'Approved', date: daysAgo(10), by: 'Rajesh Kumar', remarks: 'Approved' },
      { status: 'Assigned', date: daysAgo(9), by: 'Rajesh Kumar', remarks: 'Assigned to WoodCraft | Rate: ₹18,000' },
      { status: 'In Progress', date: daysAgo(9), by: 'WoodCraft Solutions', remarks: 'Rate finalized at ₹16,500. Work started' },
      { status: 'Resolved', date: daysAgo(8), by: 'WoodCraft Solutions', remarks: 'Door motor replaced. OTP verified.' },
      { status: 'Closed', date: daysAgo(7), by: 'Anita Desai', remarks: 'Confirmed working properly' },
    ]
  },
  {
    id: 'TKT-2025-0007', locCode: 'PUN-001', locName: 'Pune FC Road', state: 'Maharashtra',
    storeContactNo: '9876543216', issueType: 'HVAC/AC', priority: 'medium',
    description: 'Window AC in manager cabin making unusual noise. Cooling capacity reduced.',
    photoUrl: null, videoUrl: null,
    status: 'Overdue', createdBy: 'USR002', createdByName: 'Priya Sharma', createdDate: daysAgo(8),
    approvedBy: 'USR005', approvedByName: 'Neha Gupta', approveDate: daysAgo(7),
    assignedTo: 'VND003', vendorName: 'CoolBreeze HVAC', vendorContactNo: '9988776603',
    expectedDate: daysAgo(2), otpSent: false, vendorOtp: null,
    remarks: 'Vendor delayed', amcType: 'AMC',
    quotedRate: 6000, vendorCounterRate: null, finalizedRate: 6000, rateFinalized: true, rateStatus: 'finalized',
    rateHistory: [{ by: 'Neha Gupta', rate: 6000, date: daysAgo(7), action: 'quoted' }, { by: 'CoolBreeze HVAC', rate: 6000, date: daysAgo(6), action: 'accepted' }],
    vendorMedia: [], repairPhotoUrl: null, actualCost: null,
    statusLogs: [
      { status: 'Pending Approval', date: daysAgo(8), by: 'System', remarks: 'Ticket created' },
      { status: 'Approved', date: daysAgo(7), by: 'Neha Gupta', remarks: 'Approved' },
      { status: 'Assigned', date: daysAgo(7), by: 'Neha Gupta', remarks: 'Assigned to CoolBreeze | Rate: ₹6,000' },
      { status: 'In Progress', date: daysAgo(6), by: 'CoolBreeze HVAC', remarks: 'Parts ordered' },
      { status: 'Overdue', date: daysAgo(2), by: 'System', remarks: 'Expected date crossed' },
    ]
  },
  {
    id: 'TKT-2025-0008', locCode: 'JAI-001', locName: 'Jaipur MI Road', state: 'Rajasthan',
    storeContactNo: '9876543217', issueType: 'Electrical', priority: 'high',
    description: 'UPS system failure in server room. Backup power not functioning.',
    photoUrl: null, videoUrl: null,
    status: 'Escalated', createdBy: 'USR006', createdByName: 'Vikram Singh', createdDate: daysAgo(4),
    approvedBy: 'USR001', approvedByName: 'Rajesh Kumar', approveDate: daysAgo(4),
    assignedTo: 'VND001', vendorName: 'QuickFix Electricals', vendorContactNo: '9988776601',
    expectedDate: daysAgo(1), otpSent: false, vendorOtp: null,
    remarks: 'Escalated - High priority exceeded 24hrs', amcType: 'AMC',
    quotedRate: 35000, vendorCounterRate: null, finalizedRate: 35000, rateFinalized: true, rateStatus: 'finalized',
    rateHistory: [{ by: 'Rajesh Kumar', rate: 35000, date: daysAgo(4), action: 'quoted' }, { by: 'QuickFix Electricals', rate: 35000, date: daysAgo(4), action: 'accepted' }],
    vendorMedia: [], repairPhotoUrl: null, actualCost: null,
    statusLogs: [
      { status: 'Pending Approval', date: daysAgo(4), by: 'System', remarks: 'Ticket created' },
      { status: 'Approved', date: daysAgo(4), by: 'Rajesh Kumar', remarks: 'Approved immediately' },
      { status: 'Assigned', date: daysAgo(4), by: 'Rajesh Kumar', remarks: 'Assigned to QuickFix | Rate: ₹35,000' },
      { status: 'Escalated', date: daysAgo(3), by: 'System', remarks: 'Auto-escalated: High priority > 24hrs' },
    ]
  },
  {
    id: 'TKT-2025-0009', locCode: 'KOL-001', locName: 'Kolkata Park Street', state: 'West Bengal',
    storeContactNo: '9876543218', issueType: 'Deep Cleaning', priority: 'low',
    description: 'Quarterly deep cleaning required for entire store including storage areas.',
    photoUrl: null, videoUrl: null,
    status: 'Approved', createdBy: 'USR007', createdByName: 'Anita Desai', createdDate: daysAgo(1),
    approvedBy: 'USR005', approvedByName: 'Neha Gupta', approveDate: daysAgo(0),
    assignedTo: null, vendorName: null, vendorContactNo: null,
    expectedDate: null, otpSent: false, vendorOtp: null,
    remarks: 'Schedule for next week', amcType: 'Non-AMC',
    quotedRate: null, vendorCounterRate: null, finalizedRate: null, rateFinalized: false, rateStatus: null,
    rateHistory: [], vendorMedia: [], repairPhotoUrl: null, actualCost: null,
    statusLogs: [
      { status: 'Pending Approval', date: daysAgo(1), by: 'System', remarks: 'Ticket created' },
      { status: 'Approved', date: daysAgo(0), by: 'Neha Gupta', remarks: 'Approved - schedule for next week' },
    ]
  },
  {
    id: 'TKT-2025-0010', locCode: 'KOC-001', locName: 'Kochi MG Road', state: 'Kerala',
    storeContactNo: '9876543219', issueType: 'Signage', priority: 'low',
    description: 'Outdoor LED signage not illuminating at night.',
    photoUrl: null, videoUrl: null,
    status: 'Rejected', createdBy: 'USR002', createdByName: 'Priya Sharma', createdDate: daysAgo(6),
    approvedBy: 'USR001', approvedByName: 'Rajesh Kumar', approveDate: daysAgo(5),
    assignedTo: null, vendorName: null, vendorContactNo: null,
    expectedDate: null, otpSent: false, vendorOtp: null,
    remarks: 'Under AMC vendor scope', amcType: 'AMC',
    quotedRate: null, vendorCounterRate: null, finalizedRate: null, rateFinalized: false, rateStatus: null,
    rateHistory: [], vendorMedia: [], repairPhotoUrl: null, actualCost: null,
    statusLogs: [
      { status: 'Pending Approval', date: daysAgo(6), by: 'System', remarks: 'Ticket created' },
      { status: 'Rejected', date: daysAgo(5), by: 'Rajesh Kumar', remarks: 'Under AMC vendor scope' },
    ]
  },
  {
    id: 'TKT-2025-0011', locCode: 'MUM-001', locName: 'Mumbai Central Mall', state: 'Maharashtra',
    storeContactNo: '9876543210', issueType: 'Pest Control', priority: 'medium',
    description: 'Rodent activity spotted near food court area.',
    photoUrl: null, videoUrl: null,
    status: 'Closed', createdBy: 'USR002', createdByName: 'Priya Sharma', createdDate: daysAgo(15),
    approvedBy: 'USR001', approvedByName: 'Rajesh Kumar', approveDate: daysAgo(15),
    assignedTo: 'VND007', vendorName: 'CleanSpace Facility', vendorContactNo: '9988776607',
    expectedDate: daysAgo(12), otpSent: true, vendorOtp: '564738', remarks: 'Completed', amcType: 'AMC',
    quotedRate: 10000, vendorCounterRate: null, finalizedRate: 9500, rateFinalized: true, rateStatus: 'finalized',
    rateHistory: [{ by: 'Rajesh Kumar', rate: 10000, date: daysAgo(15), action: 'quoted' }, { by: 'CleanSpace Facility', rate: 9500, date: daysAgo(14), action: 'countered' }, { by: 'Rajesh Kumar', rate: 9500, date: daysAgo(14), action: 'accepted' }],
    vendorMedia: [{ type: 'photo', url: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=300', name: 'treatment_done.jpg', uploadedAt: daysAgo(12) }],
    repairPhotoUrl: null, actualCost: 9500,
    statusLogs: [
      { status: 'Pending Approval', date: daysAgo(15), by: 'System', remarks: 'Ticket created' },
      { status: 'Approved', date: daysAgo(15), by: 'Rajesh Kumar', remarks: 'Approved' },
      { status: 'Assigned', date: daysAgo(14), by: 'Rajesh Kumar', remarks: 'Assigned to CleanSpace' },
      { status: 'In Progress', date: daysAgo(13), by: 'CleanSpace Facility', remarks: 'Treatment started' },
      { status: 'Resolved', date: daysAgo(12), by: 'CleanSpace Facility', remarks: 'Treatment complete' },
      { status: 'Closed', date: daysAgo(11), by: 'Priya Sharma', remarks: 'Confirmed' },
    ]
  },
  {
    id: 'TKT-2025-0012', locCode: 'DEL-001', locName: 'Delhi CP Plaza', state: 'Delhi',
    storeContactNo: '9876543211', issueType: 'Civil Work', priority: 'medium',
    description: 'Parking area concrete floor developing cracks.',
    photoUrl: null, videoUrl: null,
    status: 'Reopened', createdBy: 'USR006', createdByName: 'Vikram Singh', createdDate: daysAgo(12),
    approvedBy: 'USR001', approvedByName: 'Rajesh Kumar', approveDate: daysAgo(12),
    assignedTo: 'VND008', vendorName: 'BuildRight Civil', vendorContactNo: '9988776608',
    expectedDate: daysAgo(5), otpSent: true, vendorOtp: '847291',
    remarks: 'Reopened - quality issue', amcType: 'Non-AMC',
    quotedRate: 30000, vendorCounterRate: 28000, finalizedRate: 28000, rateFinalized: true, rateStatus: 'finalized',
    rateHistory: [{ by: 'Rajesh Kumar', rate: 30000, date: daysAgo(12), action: 'quoted' }, { by: 'BuildRight Civil', rate: 28000, date: daysAgo(11), action: 'countered' }, { by: 'Rajesh Kumar', rate: 28000, date: daysAgo(11), action: 'accepted' }],
    vendorMedia: [], repairPhotoUrl: null, actualCost: 28000,
    statusLogs: [
      { status: 'Pending Approval', date: daysAgo(12), by: 'System', remarks: 'Ticket created' },
      { status: 'Approved', date: daysAgo(12), by: 'Rajesh Kumar', remarks: 'Approved' },
      { status: 'Assigned', date: daysAgo(11), by: 'Rajesh Kumar', remarks: 'Assigned to BuildRight' },
      { status: 'In Progress', date: daysAgo(10), by: 'BuildRight Civil', remarks: 'Work started' },
      { status: 'Resolved', date: daysAgo(6), by: 'BuildRight Civil', remarks: 'Patching complete' },
      { status: 'Reopened', date: daysAgo(5), by: 'Vikram Singh', remarks: 'Cracks reappearing' },
    ]
  },
  {
    id: 'TKT-2025-0013', locCode: 'BLR-001', locName: 'Bangalore Indiranagar', state: 'Karnataka',
    storeContactNo: '9876543212', issueType: 'Glass/Window', priority: 'high',
    description: 'Display window glass cracked after impact. Safety glass replacement needed.',
    photoUrl: null, videoUrl: null,
    status: 'Pending Approval', createdBy: 'USR007', createdByName: 'Anita Desai', createdDate: daysAgo(0),
    approvedBy: null, approvedByName: null, approveDate: null,
    assignedTo: null, vendorName: null, vendorContactNo: null,
    expectedDate: null, otpSent: false, vendorOtp: null, remarks: '', amcType: 'Non-AMC',
    quotedRate: null, vendorCounterRate: null, finalizedRate: null, rateFinalized: false, rateStatus: null,
    rateHistory: [], vendorMedia: [], repairPhotoUrl: null, actualCost: null,
    statusLogs: [{ status: 'Pending Approval', date: daysAgo(0), by: 'System', remarks: 'Ticket created' }]
  },
  {
    id: 'TKT-2025-0014', locCode: 'MUM-001', locName: 'Mumbai Central Mall', state: 'Maharashtra',
    storeContactNo: '9876543210', issueType: 'Electrical', priority: 'medium',
    description: 'Emergency exit lights not working on 3rd floor.',
    photoUrl: null, videoUrl: null,
    status: 'Closed', createdBy: 'USR002', createdByName: 'Priya Sharma', createdDate: daysAgo(20),
    approvedBy: 'USR005', approvedByName: 'Neha Gupta', approveDate: daysAgo(20),
    assignedTo: 'VND001', vendorName: 'QuickFix Electricals', vendorContactNo: '9988776601',
    expectedDate: daysAgo(17), otpSent: true, vendorOtp: '293847', remarks: 'Completed on time', amcType: 'AMC',
    quotedRate: 4000, vendorCounterRate: null, finalizedRate: 3800, rateFinalized: true, rateStatus: 'finalized',
    rateHistory: [{ by: 'Neha Gupta', rate: 4000, date: daysAgo(20), action: 'quoted' }, { by: 'QuickFix Electricals', rate: 3800, date: daysAgo(19), action: 'countered' }, { by: 'Neha Gupta', rate: 3800, date: daysAgo(19), action: 'accepted' }],
    vendorMedia: [{ type: 'photo', url: 'https://images.unsplash.com/photo-1621905252507-b35492CC74b4?w=300', name: 'lights_fixed.jpg', uploadedAt: daysAgo(17) }],
    repairPhotoUrl: null, actualCost: 3800,
    statusLogs: [
      { status: 'Pending Approval', date: daysAgo(20), by: 'System', remarks: 'Ticket created' },
      { status: 'Approved', date: daysAgo(20), by: 'Neha Gupta', remarks: 'Approved' },
      { status: 'Assigned', date: daysAgo(19), by: 'Neha Gupta', remarks: 'Assigned to QuickFix' },
      { status: 'In Progress', date: daysAgo(18), by: 'QuickFix Electricals', remarks: 'Work started' },
      { status: 'Resolved', date: daysAgo(17), by: 'QuickFix Electricals', remarks: 'All lights replaced' },
      { status: 'Closed', date: daysAgo(16), by: 'Priya Sharma', remarks: 'Confirmed' },
    ]
  },
  {
    id: 'TKT-2025-0015', locCode: 'HYD-001', locName: 'Hyderabad Banjara Hills', state: 'Telangana',
    storeContactNo: '9876543214', issueType: 'Carpentry', priority: 'low',
    description: 'Shelving units in storage room need repair.',
    photoUrl: null, videoUrl: null,
    status: 'In Progress', createdBy: 'USR006', createdByName: 'Vikram Singh', createdDate: daysAgo(4),
    approvedBy: 'USR001', approvedByName: 'Rajesh Kumar', approveDate: daysAgo(3),
    assignedTo: 'VND004', vendorName: 'WoodCraft Solutions', vendorContactNo: '9988776604',
    expectedDate: daysLater(3), otpSent: false, vendorOtp: null, remarks: '', amcType: 'Non-AMC',
    quotedRate: 7000, vendorCounterRate: null, finalizedRate: 7000, rateFinalized: true, rateStatus: 'finalized',
    rateHistory: [{ by: 'Rajesh Kumar', rate: 7000, date: daysAgo(3), action: 'quoted' }, { by: 'WoodCraft Solutions', rate: 7000, date: daysAgo(3), action: 'accepted' }],
    vendorMedia: [], repairPhotoUrl: null, actualCost: null,
    statusLogs: [
      { status: 'Pending Approval', date: daysAgo(4), by: 'System', remarks: 'Ticket created' },
      { status: 'Approved', date: daysAgo(3), by: 'Rajesh Kumar', remarks: 'Approved' },
      { status: 'Assigned', date: daysAgo(3), by: 'Rajesh Kumar', remarks: 'Assigned to WoodCraft | Rate: ₹7,000' },
      { status: 'In Progress', date: daysAgo(2), by: 'WoodCraft Solutions', remarks: 'Rate accepted. Materials procured' },
    ]
  },
];

export const ROLE_LABELS = {
  admin: 'Area Manager',
  store: 'Store User',
  vendor: 'Vendor',
  superadmin: 'R & M Manager'
};
